module.exports = __webpack_public_path__ + "img/serie35.be05631a.jpg";